import weatherMockupData from '@/api/common/mock/weather.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

export function weatherGet(call_Url) {
  return request({
    url: call_Url,
    // headers: { 'Access-Control-Allow-Origin': '*' },
    method: 'GET'
  })
}

export function weatherPost(params) {
  return request({
    url: '/weather/present/SITE_ID',
    method: 'POST',
    data: params
  })
}
